<template>
  <v-app>
    <v-banner
      v-if="appEnv !== 'production'"
      max-width="490px"
      width="100%"
      max-height="75px"
      class="py-1"
      position="fixed"
      rounded
      style="bottom: var(--v-safe-area-bottom); right: 1px; z-index: 2147483647; background: rgba(255, 0, 0, 0.4);color: #fff; pointer-events: none; user-select: none"
    >
      <div class="text-center">
        You are viewing a development version of this site (environment: {{ appEnv }}<template v-if="appVersion">
          , v{{ appVersion }}
        </template><template v-if="appBuildNumber">
          build {{ appBuildNumber }}
        </template>)
      </div>
    </v-banner>
    <app-error-messages />
    <v-btn
      v-if="$auth.user && ![ROUTES.ANNOTATIONS_EDIT].includes($route.name)"
      @click="logout"
      class="logout"
      variant="text"
    >
      Logout
    </v-btn>
    <v-main>
      <slot />
    </v-main>
  </v-app>
</template>

<script lang="ts">
import { defineComponent } from "vue"
import AppErrorMessages from "@/components/AppErrorMessages.vue"

export default defineComponent({
  components: {AppErrorMessages},
  computed: {
    appEnv() {
      return import.meta.env.VITE_APP_ENV
    },
    appVersion() {
      return import.meta.env.VITE_APP_VERSION
    },
    appBuildNumber() {
      return import.meta.env.VITE_APP_BUILD_NUMBER
    },
    userTitleFont() {
      return this.$auth.user?.settings?.title_font || 'Outfit'
    },
    userParagraphFont() {
      return this.$auth.user?.settings?.paragraph_font || 'Filson Pro'
    },
    fontSizeAdjust() {
      return this.$auth.user?.settings?.font_size == 'Large' ? 0.56 : this.$auth.user?.settings?.font_size == 'Medium' ? 0.53 : 'unset'
    },
    primaryFontColor() {
      return this.$auth.user?.settings?.primary_font_color == '#111110' ? 'unset' : this.$auth.user?.settings?.primary_font_color || 'inherit'
    },
    secondaryFontColor() {
      return this.$auth.user?.settings?.secondary_font_color == '#727272' ? 'unset' : this.$auth.user?.settings?.secondary_font_color || 'inherit'
    },
  },
  methods: {
    async logout() {
      await this.$auth.logout()
      await this.$router.push(this.$routeTo(this.ROUTES.LOGIN))
    }
  },
})
</script>

<style lang="scss">
#app .text-secondary {
  color: #727272 !important;
}
</style>

<style lang="scss" scoped>
.logout {
  position: fixed;
  top: var(--v-safe-area-top);
  right: 0;
  margin: 10px;
  z-index: 1;
}
</style>
